<template>
  <div>
    <Modal :options="{width: '30vw',type: 'danger'}" @close="$emit('close')">
      <div class="title">Eliminar documento</div>
      <div class="body">
        <p class="text-center">Eliminar {{ evidencia.nombre_original }}</p>
        <p class="text-center">La eliminación de un documento es permanente, no se puede deshacer <br/> ¿Deseas continuar?</p>
      </div>
      <div class="footer">
        <div class="row">
          <div class="col-sm-12 text-right">
            <button class="btn btn-primary mr-2" @click="eliminar_archivo">Eliminar</button>
            <button class="btn btn-danger" @click="$emit('close')">Cancelar</button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script type="text/javascript">
  import Modal from '@/components/Modal'

  import apiSolicitud from '@/apps/formalizacion/api/v2/solicitudes'

  export default {
    components: {
      Modal
    }
    ,props: {
      solicitud: {
        type: Object
        ,default() {
          return {
            id: null
          }
        }
      }
      ,incidencia: {
        type: Object
        ,default() {
          return {
            id: null
          }
        }
      }
      ,evidencia: {
        type: Object
        ,default() {
          return {
            id: null
            ,nombre_original: null
          }
        }
      }
    }
    ,methods: {
      async eliminar_archivo() {
        try {
          let res = (await apiSolicitud.incidencias_evidencias_eliminar(this.solicitud.id, this.incidencia.id, this.evidencia.id)).data;
          this.$log.info('res', res);

          this.$emit('update');
        }catch(e) {
          this.$log.info('error',e);
          this.$helper.showAxiosError(e,'Error');
        }
      }
    }

  }
</script>